import { Helmet } from "react-helmet-async";

export default function SEO({
  title = "Tømrermester Søren Emil v/Jacob Heiselberg | Tømrer i Ribe",
  description = "Professionelt tømrerfirma i Ribe, der kombinerer solidt tømrerarbejde med præcision og faglig stolthed. Kontakt os for et uforpligtende tilbud.",
  ogTitle,
  ogDescription,
  ogImage = "https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/toemrermester-soeren-emil-ved-jacob-heiselberg-logo.webp",
  canonical,
  schema
}) {
  const effectiveOgTitle = ogTitle || title;
  const effectiveOgDesc = ogDescription || description;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={effectiveOgTitle} />
      <meta property="og:description" content={effectiveOgDesc} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={effectiveOgTitle} />
      <meta name="twitter:description" content={effectiveOgDesc} />
      <meta name="twitter:image" content={ogImage} />
      {canonical && <link rel="canonical" href={canonical} />}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
